export default {
  adminLogoutOptions: {
    backToAdmin: "Zurück zu Admin",
    logout: "Logout",
  },
  portalLogoutOptions: { logout: "Logout" },
  logLevels: {
    trace: "Detailliert",
    debug: "Debug",
    info: "Normal",
    error: "Nur Fehler",
  },
  salutations: {
    NotSpecified: "Keine Angabe",
    Mr: "Herr",
    Ms: "Frau",
    NonBinary: "Divers",
  },
  contactSalutations: {
    NotSpecified: "Keine Angabe",
    Mr: "Herr",
    Ms: "Frau",
    NonBinary: "Divers",
    Enterprise: "Firma",
    Family: "Familie",
    Club: "Verein",
  },
  accountState: {
    Active: "Aktiv",
    Locked: "Gesperrt",
    Deleted: "Gelöscht",
    AccountNotConfirmed: "E-Mail nicht bestätigt",
    ActivationEmailSent: "Aktivierungs-E-Mail versendet",
  },
  billingReportApproach: {
    CashRegister: "Kasse",
    Operator: "Bediener",
  },
  cardDevices: {
    None: "Keine Anbindung",
    External: "Externes Gerät ohne Anbindung",
    Hobex: "Hobex ViA",
    ZVT: "Hobex ZVT",
    GPtom: "GP tom",
  },
  drawerDevices: {
    None: "Keine Anbindung",
    Sunmi: "Sunmi",
    Printer: "Drucker",
  },
  paymentTypes: {
    Deposit: "Einzahlung",
    Total: "Gesamtumsatz",
    Withdrawal: "Auszahlung",
    CashInDrawer: "Bar in Lade",
  },
  receiptTypes: {
    Paper: "Druck",
    Email: "E-Mail",
    NoOutput: "Nicht ausgegeben",
  },
  printerWidths: {
    31: "31 Zeichen",
    32: "32 Zeichen",
    36: "36 Zeichen",
    41: "41 Zeichen",
    42: "42 Zeichen",
    48: "48 Zeichen",
  },
  durations: {
    Today: "Heute",
    Yesterday: "Gestern",
    ThisWeek: "Diese Woche",
    ThisMonth: "Dieser Monat",
    ThisYear: "Dieses Jahr",
    Custom: "Individuell",
  },
  discountTypes: {
    "%": "Prozent",
    "€": "Euro",
  },
  transferTypes: {
    Sale: "Verkauf",
    Refund: "Gutschrift",
    Void: "Storno",
    Cancel: "Belegstorno",
  },
} as const
